import Loading from "../images/loading1.png"
export default function PageLoader() {
  return (
    <div>
      <img src={Loading} alt="loading icon" className="loadingIcon" />
      <p className="mt-2">Please wait...</p>
    </div>
  );
}